import React from "react";
import { useTheme } from '@mui/material/styles';

export const InformativaPrivacy = () => {
    const theme = useTheme();

    return (
        <React.Fragment>
            Gentile Sig./Sig.ra,<br />

						I dati personali che conferirà con la compilazione del presente modulo on line saranno trattati
						utilizzando modalità manuali, informatiche e telematiche, nel rispetto e nei limiti stabiliti dalla
						normativa vigente.
            <br />
						DICHIARAZIONE DI PRESA VISIONE DELL’INFORMATIVA PRIVACY. Dichiaro di avere letto e preso conoscenza
						delle informazioni, rese ai sensi dell’art. 13 del Regolamento UE 2016/679, relative al trattamento
						dei miei dati personali, pubblicate, sul presente sito, alla pagina web {" "}
            <a style={{ color: theme.palette.primary.main }} href={"http://www.aslcittaditorino.it/privacy/"}
                target="_blank"
                rel="noopener noreferrer">www.aslcittaditorino.it/privacy/</a>.<br />
        </React.Fragment>
    )
}